import React, { FC, Dispatch, SetStateAction } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography, FormGroup, Switch, FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import { StyledModalDiv } from "../../../../../util/accordianStyles";
import useAptSelector from "./useAptSelector";

const StyledDivRowSpace = styled("div")({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "flex-start",
  flexDirection: "column",
  padding: 20,
  height: 200,
});

const StyledDivRow = styled("div")({
  display: "flex",
  justifyContent: "space-around",
});

const StyledDivRowStart = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: 5,
  paddingTop: 20,
});

const StyledDivRowStart2 = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginRight: 45,
  padding: 5,
});

const StyledInput = styled("input")({
  padding: 5,
  marginLeft: 10,
});

const StyledDivFlexCenter = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingBottom: 40,
});

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

interface AptChangeProps {
  handleClose: () => void;
  open: boolean;
  serviceId: string;
  setSearch: Dispatch<SetStateAction<boolean>>;
}

const AptChangeModal: FC<AptChangeProps> = ({
  handleClose,
  open,
  serviceId,
  setSearch,
}) => {
  const {
    handleKeyDown,
    preventEnterEffects,
    handleSubmit,
    handleChange,
    handleToggle,
    err,
    toggleEmail,
    isLoading,
    modalStyle,
    time,
    date
  } = useAptSelector(serviceId, setSearch, handleClose);

  const body = (
    <StyledModalDiv style={modalStyle} onKeyDown={handleKeyDown}>
      <StyledDiv>
        <StyledDivRowSpace>
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
            Add Appointment
          </Typography>

          <StyledDivRowStart>
            <Typography style={{ fontWeight: "bold" }}>Date: </Typography>

            <StyledInput
              type="date"
              value={date}
              onChange={(e) => handleChange(e, "date")}
              onKeyDown={preventEnterEffects}
            />
          </StyledDivRowStart>

          <StyledDivRowStart2>
            <Typography style={{ fontWeight: "bold" }}>Time: </Typography>

            <StyledInput
              type="time"
              value={time}
              onChange={(e) => handleChange(e, "time")}
              onKeyDown={preventEnterEffects}
            />
          </StyledDivRowStart2>
        </StyledDivRowSpace>
      </StyledDiv>

      <StyledDivFlexCenter>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={toggleEmail}
                onChange={handleToggle}
              />
            }
            label="Send Email"
          />
        </FormGroup>
      </StyledDivFlexCenter>

      {err && (
        <Typography style={{ color: "red", padding: 20 }}>{err}</Typography>
      )}

      <StyledDivRow>
        <Button onClick={handleClose} variant="contained" color="inherit">
          Cancel
        </Button>
        {isLoading ? (
          <Button variant="contained" size="large" color="primary">
            <CircularProgress color="inherit" size={30} />
          </Button>
        ) : (
          <Button
            size="large"
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            Confirm
          </Button>
        )}
      </StyledDivRow>
    </StyledModalDiv>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      {body}
    </Modal>
  );
};

export default AptChangeModal;
